import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/CookieConsent.css";

export default function CookieConsent() {
  const { t } = useTranslation("cookies");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setVisible(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <p>{t("message")}</p>
      <div className="cookie-buttons">
        <button onClick={acceptCookies} className="accept">{t("accept")}</button>
        <button onClick={rejectCookies} className="reject">{t("reject")}</button>
      </div>
    </div>
  );
}
